import { useForm } from '@tanstack/react-form'
import { isRequiredValidator } from 'src/utils/form/validation'
import { useQualification, QualificationData } from 'src/utils/hooks/use-mcp-user-qualification-info'

import Button from '../buttons/button'
import Form from '../fields/form'
import ListboxField from '../fields/listbox.field'
import TextField from '../fields/text.field'
import Icon from '../icons/icon'
import BasicModal from './modal.basic'

const JOB_TITLE_OPTIONS = [
  { value: 'Data Scientist / Data Engineer', label: 'Data Scientist / Data Engineer' },
  { value: 'Software Engineer / Developer', label: 'Software Engineer / Developer' },
  { value: 'Product / Business Operations', label: 'Product / Business Operations' },
  { value: 'Sales / Marketing', label: 'Sales / Marketing' },
  { value: 'Leadership / Executive', label: 'Leadership / Executive' },
  { value: 'Student', label: 'Student' },
  { value: 'Other', label: 'Other' },
]

const MCP_EXPERIENCE_OPTIONS = [
  { value: 'Getting Started', label: 'Getting Started' },
  { value: 'Pilot', label: 'Pilot' },
  { value: 'Production', label: 'Production' },
]

interface Props {
  isOpen: boolean
  onComplete?: () => void
}

export const UserQualificationModal = ({ isOpen, onComplete }: Props) => {
  const { completeQualificationInfo } = useQualification()

  const form = useForm({
    defaultValues: {
      jobTitle: '',
      company: '',
      mcpExperience: '',
    },
    onSubmit: async ({ value }) => {
      await completeQualificationInfo(value as QualificationData)
      onComplete?.()
    },
  })

  //explicit do nothing close since user can't dismiss this until completed
  const onClose = () => {}

  return (
    <BasicModal.Wrapper isOpen={isOpen} className='sm:max-w-lg' onClose={onClose}>
      <BasicModal.Body
        title='Tell us about yourself'
      >
        <Form<QualificationData> form={form} id='qualification-form'>
          <div className='flex flex-col gap-4'>
            <p className='mb-2 text-sm text-gray-600'>
              Help us personalize your experience by answering a few quick questions.
            </p>
            <ListboxField
              name='jobTitle'
              label='Job Role'
              placeholder='Select your job role'
              options={JOB_TITLE_OPTIONS}
              form={form}
              validators={{ onChange: isRequiredValidator() }}
            />
            <TextField
              name='company'
              label='Company Name'
              placeholder='Enter your company name'
              form={form}
              validators={{ onChange: isRequiredValidator() }}
            />
            <ListboxField
              name='mcpExperience'
              label='MCP Experience'
              placeholder='Select your MCP experience level'
              options={MCP_EXPERIENCE_OPTIONS}
              form={form}
              validators={{ onChange: isRequiredValidator() }}
            />
          </div>
        </Form>
      </BasicModal.Body>
      <BasicModal.Footer>
        <form.Subscribe selector={(state) => [state.isSubmitting, state.isFieldsValid]}>
          {([isSubmitting, isFieldsValid]) => (
            <Button kind='primary' disabled={!isFieldsValid || isSubmitting} type='submit' form='qualification-form'>
              {isSubmitting && <Icon className='mr-2' isSpinning name='refresh' size='xs' />} Get Started
            </Button>
          )}
        </form.Subscribe>
      </BasicModal.Footer>
    </BasicModal.Wrapper>
  )
}
